import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
// import AddCommentIcon from '@mui/icons-material/AddComment';
// import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import CloseIcon from '@mui/icons-material/Close';
// import ReplyIcon from '@mui/icons-material/Reply';
import dayjs from "dayjs";
import relativeTime from 'dayjs/plugin/relativeTime';
import { addSupportTicketCommentAction } from "../../Actions/SupportTicketAction";
import { daysAgo } from "../../utils/CommonFunctions";
import { MyAccountCircleIcon, MyArrowUpwardIcon, MyCloseIcon, MyReplyIcon } from "../../Assets/svg/MyIcons";
dayjs.extend(relativeTime);
 
const DialogOpenComponent = ({ ticketId, data, onClose, parentComponent }) => {
 
    if (!data || data.trim() === "") {
        data = "null";
    }

    const [noteData, setNoteData] = useState("");
    const [isOpenCommentView, setIsOpenCommentView] = useState(false);
    const [comment, setComment] = useState("");
    const [replyComment, setReplyComment] = useState("");
    const [commentId, setCommentId] = useState("");
    const [isOpenReplyCommentView, setIsOpenReplyCommentView] = useState(false);

    const handleCommentClick = async() => {
        if(ticketId){
            if(comment !== ""){
                await addSupportTicketCommentAction(
                    {
                        comment,
                        ticketId,
                    }
                )
                .then((res) => {
                    setNoteData(res.data)
                })
                .catch((error) => {
                })
                setComment("");
            } else if(commentId) {
                await addSupportTicketCommentAction(
                    {
                        comment: replyComment,
                        ticketId,
                        commentId
                    }
                )
                .then((res) => {
                    setNoteData(res.data)
                })
                .catch((error) => {
                })

                setReplyComment("");
            }
        }
    }

    useEffect(()=>{
        if(parentComponent === "notes"){
            setNoteData(JSON.parse(data))
        }
    }, [data,parentComponent])
 
    return (
        <Dialog open={true} onClose={onClose} fullWidth>
            <DialogTitle>
                {/* <strong>Domain URL</strong> */}
            </DialogTitle>
            <DialogContent>
                {data === "null" ? (
                    <p>No Data Found</p>
                ) : (
                    <div>
                        {
                            parentComponent === "notes" ? (
                                <div>
                                    <p style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "2px" }}>
                                        <span className=""><MyAccountCircleIcon /></span>
                                        <span>{noteData.note}</span>
                                    </p>
                                    <div className="h6 ms-8">
                                        <span className="">{daysAgo(noteData.createdAt)}</span>
                                        <span className="ms-3 cursor-pointer">
                                            { !isOpenCommentView && 
                                                <MyReplyIcon 
                                                    onClick= {()=>{setIsOpenCommentView(!isOpenCommentView);}}
                                                />
                                            }
                                            { isOpenCommentView  && 
                                                <MyCloseIcon 
                                                    onClick= {()=>{setIsOpenCommentView(!isOpenCommentView); setComment("");}}
                                                />
                                            }
                                        </span>
                                        {
                                            isOpenCommentView && <div className="d-flex">
                                                <input 
                                                    className="form-control ps-5"
                                                    type="text"
                                                    value={comment}
                                                    onChange={(e) => setComment(e.target.value)}
                                                    placeholder="Enter comment text here"
                                                />
                                                { comment !== "" && 
                                                    <span>
                                                        <button className="btn btn-primary ms-2">
                                                            <MyArrowUpwardIcon 
                                                                onClick= {()=>{handleCommentClick();setIsOpenCommentView(false);}}
                                                            />
                                                        </button>
                                                    </span>
                                                }
                                            </div>
                                        }
                                        <div>
                                            { noteData?.replies && noteData.replies.map((comment, index) => (
                                                <div key={index}>
                                                    <div className="h3">
                                                        <div className="">
                                                            <span className="h1"><MyAccountCircleIcon /></span>
                                                            <span className="ms-1 h4">{comment.comment}</span>
                                                        </div>
                                                        <div className="h5 ms-7">
                                                            <span className="">{daysAgo(comment.createdAt)}</span>
                                                            <span className="ms-3 cursor-pointer">
                                                                { comment.id !== commentId && !comment.reply && 
                                                                    <MyReplyIcon 
                                                                        onClick= {()=>{setIsOpenReplyCommentView(!isOpenReplyCommentView);setCommentId(comment.id);}}
                                                                    />
                                                                }
                                                                { isOpenReplyCommentView && comment.id === commentId && 
                                                                    <MyCloseIcon 
                                                                        onClick= {()=>{setIsOpenReplyCommentView(!isOpenReplyCommentView); setCommentId("");}}
                                                                    />
                                                                }
                                                            </span>
                                                            {
                                                                comment?.reply?.length && <div className="">
                                                                    <div className="">
                                                                        <span className="h1"><MyAccountCircleIcon /></span>
                                                                        <span className="ms-1 h4">{comment.reply[0].comment}</span>
                                                                    </div>
                                                                    <div className="h5 ms-7">
                                                                        <span className="">{daysAgo(comment.reply[0].createdAt)}</span>
                                                                    </div>
                                                                </div>
                                                            }
                                                            {
                                                                isOpenReplyCommentView && comment.id === commentId && <div className="d-flex">
                                                                    <input 
                                                                        className="form-control ps-5"
                                                                        type="text"
                                                                        value={replyComment}
                                                                        onChange={(e) => setReplyComment(e.target.value)}
                                                                        placeholder="Enter comment text here"
                                                                    />
                                                                    { replyComment !== "" && 
                                                                        <span>
                                                                            <button className="btn btn-primary ms-2">
                                                                                <MyArrowUpwardIcon 
                                                                                    onClick= {()=>{handleCommentClick();setIsOpenReplyCommentView(false); setCommentId(""); setReplyComment("");}}
                                                                                />
                                                                            </button>
                                                                        </span>
                                                                    }
                                                                </div>
                                                            }
                                                        </div>
                                                        
                                                    </div>
                                                </div>
                                            )
                                            )}
                                        </div>
                                    </div>
                                    
                                </div>
                            ) : (
                                <p style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
                                    {data}
                                </p>
                            ) 
                        }
                    </div>
                )}
                <button
                    onClick={onClose}
                    className="btn btn-primary"
                    style={{
                        marginTop: "16px",
                        marginLeft: "auto",
                        display: "block",
                        width: "fit-content",
                    }}
                >
                    Close
                </button>
            </DialogContent>
        </Dialog>
    );
};
 
export default DialogOpenComponent;